import Vue from 'vue'
import Vuex from 'vuex'
import { PARTNER_CONFIG } from '@/common/js/partnerConfig'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    openedTab: '首頁',
    openedEnTab: 'Index',
    tabsList:[
        {
          menuName: '首頁',
          menuNameEn: 'Index',
          pageUrl: 'index',
        }
    ],
    lang: 'zh',
    isRouterAlive:true,
    hasAuth: false,
    partnerConfig: PARTNER_CONFIG,
  },
  mutations: {
    addTab (state, data) {
      state.tabsList.push({menuName:data[0],menuNameEn:data[1], pageUrl:data[2]});
    },
    changeTab (state, arr) {
      state.openedTab = arr[0];
      state.openedEnTab = arr[1];
    },
    changeLang (state, lang) {
      state.lang = lang;
    },
    deductTab (state, index) {
      state.tabsList.splice(index, 1);
    },
    goRouter(state,data){
        state.isRouterAlive = data;
    },
    setHasAuth(state,data){
        state.hasAuth = data;
    },
    setPartnerConfig(state, config) {
      state.partnerConfig = config;
      try {
        if (config) {
          sessionStorage.setItem('partnerConfig', JSON.stringify(config));
        } else {
          sessionStorage.removeItem('partnerConfig');
        }
      } catch (e) {
        console.error(e);
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js